// extracted by mini-css-extract-plugin
export default {"tableWrapper":"InvoicesTableView_tableWrapper__FSgO6"};